import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_EXPENSES';

export async function getAllExpenses(
    userData: Record<string, string>,
    before: string,
    after: string,
    optionalProps?: Record<string, string>,
    query?: string
) {
    try {
        const response = await axios.get(
             
            `${URL}/expenses/?before=${before}&after=${after}${optionalProps?.ressource ? `&ressource=${optionalProps.ressource}` : ""}${optionalProps?.deal ? `&deal=${optionalProps.deal}` : optionalProps?.deal_parent_id ? `&deal_parent_id=${optionalProps.deal_parent_id}` : ""}${query}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des frais',
            error: error
        });
    }
}
